import { useState } from 'react';
import { FilterType } from '../FilterData';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  CancleButton,
  Wrapper,
} from '../filterOptionModal/OptionModal.styles';
import { styled } from 'styled-components';

interface Props {
  option: 'appraisalPrice' | 'minPrice';
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function PriceOption({ option, onClose, filters, setFilters }: Props) {
  const [minPrice, setMinPrice] = useState(filters[option]?.min || '');
  const [maxPrice, setMaxPrice] = useState(filters[option]?.max || '');

  const [isMinSelected, setIsMinSelected] = useState(false);
  const [isMaxSelected, setIsMaxSelected] = useState(false);

  const handleReset = () => {
    onClose();
  };
  const handleSubmit = () => {
    setFilters({
      ...filters,
      [option]: {
        min: minPrice,
        max: maxPrice,
      },
    });
    onClose();
  };
  return (
    <Wrapper>
      <OptionBox>
        {option === 'appraisalPrice' ? '감정가' : '최저가'}
        <Inner>
          <UnitInputWrapper>
            <NumberInput
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={{ padding: 0, borderRadius: 0 }}
              placeholder="최소"
              value={
                isMinSelected
                  ? minPrice
                  : minPrice === ''
                    ? ''
                    : Number(minPrice).toLocaleString()
              }
              onFocus={() => setIsMinSelected(true)}
              onBlur={() => setIsMinSelected(false)}
              onChange={(e) => setMinPrice(e.target.value)}
            />
            <span style={{ whiteSpace: 'nowrap' }}>만원</span>
          </UnitInputWrapper>
          <Text>~</Text>
          <UnitInputWrapper>
            <NumberInput
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={{ padding: 0, borderRadius: 0 }}
              placeholder="최대"
              value={
                isMaxSelected
                  ? maxPrice
                  : maxPrice === ''
                    ? ''
                    : Number(maxPrice).toLocaleString()
              }
              onFocus={() => setIsMaxSelected(true)}
              onBlur={() => setIsMaxSelected(false)}
              onChange={(e) => setMaxPrice(e.target.value)}
            />
            <span style={{ whiteSpace: 'nowrap' }}>만원</span>
          </UnitInputWrapper>
        </Inner>
      </OptionBox>
      <Bottom>
        <ButtonBox>
          <CancleButton onClick={handleReset}>취소</CancleButton>
          <ApplyButton onClick={handleSubmit}>저장</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default PriceOption;

const OptionBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 12px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: row;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
`;

const NumberInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
  }
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
